import React from 'react';
import type { FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import { StyledContainer } from '../styles';
import type { InputProps } from '../types';

import InputPhoneControl from './InputPhoneControl';

export function InputPhone<T extends FieldValues = Dictionary<string, string>>({
  control,
  css,
  helperText,
  label,
  name,
}: InputProps<T>) {
  return (
    <StyledContainer css={css}>
      <Controller<T>
        control={control}
        name={name}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <InputPhoneControl
            error={!!error}
            fullWidth
            helperText={(error?.message as string) || helperText}
            label={label}
            onChange={onChange}
            value={value}
          />
        )}
      />
    </StyledContainer>
  );
}
